export default __webpack_public_path__ + "CIC.5ed50d7.png";